import { CircularProgress, Button as MuiButton, ButtonProps as MuiButtonProps, useTheme } from '@mui/material';

type ButtonProps = MuiButtonProps & {
  isLoading?: boolean;
};

export function Button({ children, ...props }: ButtonProps) {
  const { sx, isLoading = false, ...rest } = props;
  const theme = useTheme();

  return (
    <MuiButton
      variant={props.variant || 'outlined'}
      sx={sx}
      endIcon={
        isLoading ? <CircularProgress style={{ color: theme.palette.primary.contrastText }} size={16} /> : props.endIcon
      }
      {...rest}
      disabled={isLoading || props.disabled}>
      {children}
    </MuiButton>
  );
}
